<mat-form-field appearance="fill" class="controls-alignment" [formGroup]="group">
  @if (field.description) {
    <p class="m-t-24" [innerHTML]="field.description"></p>
  }
  <mat-label>{{field.labelName}}</mat-label>
  <input matInput [formControlName]="field.labelCode" type="text" autocomplete="off" [required]="isRequired">
  <mat-hint align="start">{{field.comment}}</mat-hint>
  @for (validation of field.validations; track validation) {
    <ng-container ngProjectAs="mat-error">
      @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase())) {
        <mat-error>{{validation.message}}</mat-error>
      }
    </ng-container>
  }
</mat-form-field>


